<template>
  <div class="search-feedback">
    <p class="search-feedback__content">
      Your feedback will help us improve your search results.
    </p>
    <img
      class="search-feedback__usefull"
      :src="status === 1 ? GoodJobActive : GoodJob"
      @click="onClick(1)"
    >
    <img
      class="search-feedback__useless"
      :src="status === 0 ? GoodJobActive : GoodJob"
      @click="onClick(0)"
    >
  </div>
</template>

<script setup>
import GoodJob from '@/assets/colorIcon/good-job.svg'
import GoodJobActive from '@/assets/colorIcon/good-job-active.svg'
import { deepSearchFeedback } from '@/api/ai'
import { debounce } from '@/utils/utils'
import { useTextSearch } from '@/hooks/useTextSearch'
import { useLanguageStore } from '@/pinia/language'

const route = useRoute()
const { getTextSearchHistory } = useTextSearch()
const language = useLanguageStore()

const status = ref(null)

const onClick = (type) => {
  if (status.value === type) {
    status.value = null
    return
  }
  status.value = type
  updateFeedback(type)
}

const userAddress = computed(() => {
  const addressStr = localStorage.getItem('addressForm')
  if (addressStr == null) return null
  const address = JSON.parse(addressStr)
  return `${address.country} ${address.province} ${address.city} ${address.streetAddress}`
})

const updateFeedback = debounce(async (feedback) => {
  await deepSearchFeedback({
    search_language: language.current,
    search_query: route.query.keyword,
    category_id: route.query.categoryId,
    category_name: route.query.categoryName,
    user_address: userAddress.value,
    feedback,
    search_query_history: getTextSearchHistory()
  })
}, 400)
</script>

<style lang="less" scoped>
.search-feedback {
  display: flex;
  align-items: center;
  gap: 8px;

  &__content {
    font-family: mon-500;
    font-size: 12px;
    color: #232323;
  }

  &__usefull, &__useless {
    width: 16px;
    height: 16px;
    cursor: pointer;

    @media (hover: hover) {
      &:hover {
        filter: brightness(80%);
      }
    }
  }

  &__usefull {
    margin-left: 8px;
  }

  &__useless {
    transform: rotate(180deg);
  }
}
</style>
